// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import FlashController from "./flash_controller"
import HelloController from "./hello_controller"
import NavbarController from "./navbar_controller"
import TaskAgingController from "./task_aging_controller"
import TaskInputController from "./task_input_controller"
import RequeuePromptController from "./requeue_prompt_controller"
import CompletePromptController from "./complete_prompt_controller"
import SortableController from "./sortable_controller"

application.register("flash", FlashController)
application.register("hello", HelloController)
application.register("navbar", NavbarController)
application.register("task-aging", TaskAgingController)
application.register("task-input", TaskInputController)
application.register("requeue-prompt", RequeuePromptController)
application.register("complete-prompt", CompletePromptController)
application.register("sortable", SortableController)
